import useCampingMap, { CampingMapConfig } from '@hooks/CampingMap';
import useCampingMapData from '@hooks/CampingMap/useCampingMapData';
import { useQuery } from '@hooks/Common/useQuery';
import RPModal from '@pages/Explore/components/RPModal';
import { Spin } from 'antd';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import './style.less';

const CampingMap = () => {
  const mapContainer = useRef<SVGSVGElement>(null);
  const [query, setQuery] = useQuery();
  const rpId = useMemo(() => {
    return query.get('rpId');
  }, [query]);
  const open = useMemo(() => rpId != null, [rpId]);
  const mapConfigQuery = useMemo(() => [], []);
  const { data: mapConfig, loading } = useCampingMapData(mapConfigQuery);

  const onClose = useCallback(() => {
    setQuery('rpId', null);
  }, [setQuery]);

  const onNodeClick = useCallback(
    (node: string) => {
      const rentalPropertyId = mapConfig?.mappingData[node];
      if (rentalPropertyId) setQuery('rpId', rentalPropertyId);
    },
    [mapConfig?.mappingData, setQuery],
  );

  const config = useMemo<CampingMapConfig>(() => {
    if (!mapConfig) {
      return {
        mapSVG: undefined,
        mappingData: undefined,
        onNodeClick,
      };
    }
    const parser = new DOMParser();
    const parsed = parser.parseFromString(mapConfig.svgData, 'text/xml');
    const svgElem: SVGElement = parsed.getElementsByTagName('svg')[0];
    return {
      mapSVG: svgElem,
      mappingData: mapConfig.mappingData,
      onNodeClick,
    };
  }, [mapConfig, onNodeClick]);
  const { setContainerRef } = useCampingMap(config);

  useEffect(() => {
    setContainerRef(mapContainer);
  }, [setContainerRef]);

  return (
    <Spin spinning={loading}>
      <div className="camping-map-container">
        <svg ref={mapContainer} />
      </div>
      <RPModal rpId={rpId} open={open} onClose={onClose} />
    </Spin>
  );
};

export default CampingMap;
